module.exports = __webpack_public_path__ + "static/media/babyhealth-app_2screen.319da6ec.png";